<template>
    <div class="class-1">
        <AppHeader />
    <div class="dashboard-container">
      <h1 class="dashboard-title">Customer Portal</h1>
      
      <div class="cards-container">
        <!-- Customers Management Card -->
        <div class="dashboard-card" @click="navigateTo('/customers')">
          <div class="card-icon">
            <!-- <img class="customericon" src="https://img.icons8.com/ios-filled/50/000000/customer-support.png" alt="Customer Service"> -->
            <img class="logo_icon" src="../assets/Management.png" alt="Management">
          </div>
          <div class="card-content">
            <h3>Customers Management</h3>
            <p>View, edit, and manage all customer records</p>
          </div>
          <div class="card-arrow">
            <i class="fas fa-chevron-right"></i>
          </div>
        </div>
  
        <!-- Customers Account Details Card -->
        <div class="dashboard-card" @click="navigateTo('/customersAcc')">
          <div class="card-icon">
            <!-- <img src="https://cdn-icons-png.flaticon.com/512/3132/3132693.png" alt="Accounts"> -->
            <img class="logo_icon" src="../assets/Accounts Details.png" alt="Management">
          </div>
          <div class="card-content">
            <h3>Customers Account Details</h3>
            <p>View financial transactions and account history</p>
          </div>
          <div class="card-arrow">
            <i class="fas fa-chevron-right"></i>
          </div>
        </div>
      </div>
    </div>
         
</div>
  </template>
  
  <script>
  export default {
    methods: {
      navigateTo(route) {
        this.$router.push(route);
      }
    }
  };
  </script>
  
  <style scoped>
  .dashboard-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 2rem;
  }
  .customericon{
    filter: invert(100%) sepia(100%) saturate(500%) hue-rotate(172deg);
  }
  .dashboard-title {
    text-align: center;
    margin-bottom: 2.5rem;
    font-size: 2.2rem;
  }
  
  .cards-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 2rem;
  }
  
  .dashboard-card {
    border-radius: 12px;
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
    padding: 1.5rem;
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease;
    border: 2px solid #3498db;
  }
  
  .dashboard-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 12px 20px rgba(0, 0, 0, 0.15);
  }
  
  .dashboard-card:nth-child(2) {
    border-color: #2ecc71;
  }
  
  .card-icon {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 1.5rem;
    flex-shrink: 0;
  }
  
  .card-icon img {
    width: 100%;
    height: 32px;
    filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg);


  }
  
  .card-content {
    flex-grow: 1;
  }
  
  .card-content h3 {
    margin: 0;
    font-size: 1.3rem;
  }
  
  .card-content p {
    margin: 0.5rem 0 0;
    color: #7f8c8d;
    font-size: 0.95rem;
  }
  
  .card-arrow {
    color: #bdc3c7;
    font-size: 1.2rem;
    transition: all 0.3s ease;
  }
  
  .dashboard-card:hover .card-arrow {
    color: #3498db;
    transform: translateX(5px);
  }
  
  .dashboard-card:nth-child(2):hover .card-arrow {
    color: #2ecc71;
  }
  
  @media (max-width: 768px) {
    .cards-container {
      grid-template-columns: 1fr;
    }
  }
  </style>